import { render, staticRenderFns } from "./EventPage.vue?vue&type=template&id=efa8704a&lang=pug"
import script from "./EventPage.vue?vue&type=script&lang=ts"
export * from "./EventPage.vue?vue&type=script&lang=ts"
import style0 from "./EventPage.vue?vue&type=style&index=0&id=efa8704a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports